import React from "react";
import { Message } from "./Message";
import { TectonicContext } from "./TectonicProvider";
export class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { error: this.props.error };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        const { error } = this.state;
        const { minEventCount, minEventError, className, centered = false, } = this.props;
        const { stats } = this.context;
        if (error) {
            console.error(error);
            return (React.createElement(Message, { error: true, centered: centered, className: className },
                "Failed to show visualizations:",
                React.createElement("br", null),
                error.message));
        }
        if (stats && stats.count < minEventCount) {
            return (React.createElement(Message, { error: true, centered: centered, className: className }, minEventError));
        }
        return this.props.children;
    }
}
ErrorBoundary.defaultProps = {
    minEventCount: 2,
    minEventError: "No data available for this time period",
};
ErrorBoundary.contextType = TectonicContext;
//# sourceMappingURL=ErrorBoundary.js.map